var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      style: { backgroundColor: `#${this.allConf.invited_color}` },
      attrs: { id: "app" },
    },
    [
      _c("Index", {
        attrs: {
          allConf: _vm.allConf,
          counterTime: _vm.counterTime,
          getCouponFlag: _vm.getCouponFlag,
          share_channel: _vm.share_channel,
          startTime: _vm.startTime,
        },
        on: { jumpUrl: _vm.jumpUrl, modalOpen: _vm.modalOpen },
      }),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.maskShow
          ? _c("div", { ref: "modalMask", staticClass: "modal-mask" })
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "modal" } },
        [
          _vm.modalRuleShow
            ? _c("RuleModal", {
                attrs: { ruleContont: _vm.ruleContont, Height: "7.5rem" },
                on: { modalHandler: _vm.modalHandler },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.CouponListModalShow
            ? _c("CouponListModal", {
                attrs: { couponList: _vm.couponList, myPhone: _vm.myPhone },
                on: {
                  jumpGasUrl: _vm.jumpGasUrl,
                  modalHandler: _vm.modalHandler,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.ReceivedCouponShow
            ? _c("ReceivedCoupon", {
                attrs: { couponList: _vm.couponList, myPhone: _vm.myPhone },
                on: {
                  jumpGasUrl: _vm.jumpGasUrl,
                  modalHandler: _vm.modalHandler,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "mask",
          staticClass: "mask",
          staticStyle: { display: "none" },
          attrs: { id: "weixinMask" },
          on: {
            touchstart: function ($event) {
              $event.stopPropagation()
              $event.preventDefault()
              return _vm.toggleMaskShow.apply(null, arguments)
            },
          },
        },
        [
          !_vm.isiOS
            ? _c("div", { staticClass: "guard android" })
            : _c("div", { staticClass: "guard ios" }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }